import { leftSpout, rightReceptacle, MID_ROW, type LevelConfig } from './portHelpers';

export const LEVEL_1: LevelConfig = {
  step: 1,
  title: 'STEP ONE',
  instructions: 'Artificial blood prepared. Connect a pipe to transport oxygen.',
  ports: [
    leftSpout('s1-spout-O2', MID_ROW, ['oxygen']),
    rightReceptacle('s1-recept-O2', MID_ROW, ['oxygen']),
  ],
};
